// A tiny WebAudio SFX layer. Zero assets, so nothing to download or cache.
// Synthesised tones only — swap in samples if your app needs character.

let ctx;
let muted = false;

export function setMuted(on) { muted = !!on; }
export function isMuted() { return muted; }

function audio() {
  if (muted) return null;
  // Created lazily: constructing an AudioContext before a user gesture leaves
  // it suspended on iOS, and a suspended context swallows everything silently.
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch { return null; }
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

function tone(freq, ms, { type = 'sine', gain = 0.05 } = {}) {
  const ac = audio();
  if (!ac) return;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(gain, ac.currentTime);
  // Exponential ramp to near-zero, never to zero — zero is invalid and throws.
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + ms / 1000);
  osc.connect(g).connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + ms / 1000);
}

export const boop = () => tone(660, 90);
export const tap = () => tone(880, 45, { gain: 0.03 });
export const tada = () => { tone(523, 120); setTimeout(() => tone(659, 120), 90); setTimeout(() => tone(784, 220), 180); };
export const nope = () => tone(180, 160, { type: 'square', gain: 0.04 });
